import { render } from "./Flow.vue?vue&type=template&id=449c7b5d&scoped=true"
const script = {}

import "./Flow.vue?vue&type=style&index=0&id=449c7b5d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-449c7b5d"

export default script